import { pieChartSpecSchema } from '@/core';
import { createVisualization, mapPropsToSpec, mapSpecToProps } from '@/plugin-system';
import { PieChartIcon } from './PieChartIcon';
import { PieChartOptionsEditorAdvancedSettings } from './PieChartOptionsEditorAdvancedSettings';
import { PieChartOptionsEditorSettings } from './PieChartOptionsEditorSettings';
import { PieChartPanel } from './PieChartPanel';
import { createInitialPieChartSpec, PIE_CHART_PROP_TO_SPEC_MAPPING } from './pie-chart-model';

export const PieChart = createVisualization(PieChartPanel, {
  dashboardConfig: {
    kind: 'PieChart',
    createInitialOptions: createInitialPieChartSpec,
    mapSpecToProps: (spec) => mapSpecToProps(spec, PIE_CHART_PROP_TO_SPEC_MAPPING),
    mapPropsToSpec: (props) => mapPropsToSpec(props, PIE_CHART_PROP_TO_SPEC_MAPPING),
    panelOptionsEditorComponents: [
      { label: 'Settings', content: PieChartOptionsEditorSettings },
      { label: 'Advanced', content: PieChartOptionsEditorAdvancedSettings },
    ],
    schema: pieChartSpecSchema,
    supportedDataType: 'SingleValue',
    queryEditorCapabilities: {
      disablePerQueryThreshold: true,
    },
    icon: PieChartIcon,
  },
});

export type PieChartVizProps = React.ComponentProps<typeof PieChart.Viz>;
export type PieChartVizBaseProps = React.ComponentProps<typeof PieChart.VizBase>;
